import { useState,useEffect } from "react";
import api from "../pages/AxiosFetchData";
import { useNavigate } from 'react-router-dom';
import { CatchWrapperAsync } from "../utils/catchwrapper";
import Helper from "../pages/Helper";
export const useLiveStockHook = () =>{
    const [rows, setRows] =  useState([]);
    const [component, setComponent] =  useState({});
    const [message, setmessage] =  useState('');
    const Navigate = useNavigate();
    //const [showLoader, setShowLoader] =  useState(false);
    const [value,setvalue] = useState('')

    useEffect(() => {
        // setShowLoader(true);
        //         setTimeout(() => {
        //             setShowLoader(false);
        //         }, 1000);

        GetData();
        GetComponent();
       
        
    }, []);

    const GetData = async () => {
        var response; 
        CatchWrapperAsync(async ()=>{
            response =  await api.get(`GetProduct`).refreshToken(Navigate,"productlivestock",true);
            if(response)
            {
                setRows(response.data);
            }
        },setmessage)
    };

    const GetComponent = async () => {
        var response; 
        CatchWrapperAsync(async ()=>{
            response =  await api.get(`GetComponent/1`).refreshToken(Navigate,"productlivestock");
           
            if(response)
            {
                // console.log(response.data.props)
                 setComponent(JSON.parse(response.data.props));
                 setvalue(response.data.value)
            }
        },setmessage)
    };

    const handleDetail = (props) => {
        console.log(props)
    }
    
    const columns= [
            { field: 'rowNumber', headerName: 'No.', width: 50 },
            { field: 'product_code', headerName: 'Code.', width: 250 },
            { field: 'product_name', headerName: 'Name', width: 250 },
            { field: 'descriptions', headerName: 'Desc', width: 280 },
            { field: 'units_name', headerName: 'Unit', width: 150 },
            { field: 'end_stock', headerName: 'Stock', width: 80 },
             { field: 'last_buy_price', headerName: 'HPP', width: 100, valueGetter: (value) => {
               return Helper.formatAsCurrency(value.row.last_buy_price);
              }  },
            
    ];

    return {rows,message,setmessage,columns,handleDetail,component,value}
}